import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import demo0 from "../../assets/images/demo/1447_b.jpeg";

import OrderConstant from "../../constants/OrderConstant";

import {
  getStorageList as getStorageListAction,
  getStorageListByCat as getStorageListByCatAction,
  addStorage as addStorageAction,
} from "../../redux/modules/storage";


import {
  getCategoryList as getCategoryListAction,
  update as updateAction,
} from "../../redux/modules/category";

import { toArrayClearList, inArrayValueByKey } from "../../utilities/array";

import { convertImages, fromArrayListKey } from "../../utilities/array";

import UiInputSearch from "../../components/inputs/UiInputSearch";
import UiButtonColor from "../../components/button/UiButtonColor";
import UiModalProductAdd from "../../components/modals/UiModalProductAdd";
import UiPageText from "../../components/text/UiPageText";
import UiTableAdaptive from "../../components/table/UiTableAdaptive";

import "./ProductsStyle.scss";
import Env from "../../services/Env";
import { storeData } from "../../services/Storage";

function ProductsCategorys(props) {
  const navigate = useNavigate();
  const [modalDealAddACtive, setModalDealAddActive] = useState(false);
  const [searchLine, setSearchLine] = useState(null);

  const clientsTitles = [
    { sort: false, title: "" }, 
    { sort: true, title: "Порядок" }, 
    { sort: true, title: "Название" },
  
    { sort: true, title: "Раздел" },
    { sort: true, title: "Показать на главной" },
    { sort: true, title: "Показать в меню" },
    { sort: false, title: "Удалить" },
  ];

  const [tableListOrders, setTableListOrders] = useState([]);
  const [tableHomeList, setTableHomeList] = useState([]);

  useEffect(() => {
    props.getCategoryList();
  }, []);

  useEffect(() => {
    let arr = []; 
    let arr2 = []; 
    setTableListOrders([]);
    props.category.list.map((item) => {
      let images = convertImages(item.imgs);
      item.images = images;
      arr.push([ 
        {
          button: "open", onClick: () => { 
            navigate(`/products/category/${item.id}`)
          }
        },
        {
          inputSort: `${item.sort}`,
          onBlurInput: (v) => {
            let _item = item;
            let s = _item.sort;
            if(v == 1 ){
              s++;
              _item.sort = s;
            } else {
              s--;
              _item.sort = s;
            } 
            props.update(_item).then(() => props.getCategoryList());
          },
        },

 
        { 
          input: `${item.title}`, 
          onBlurInput: (val) => {
            let _item = item;
            _item.title = val;
            props.update(_item);
          }
        },
  

      


        {
          curInfo:
            `${inArrayValueByKey(props.category.tagsList, "id", item.tag_id) ?
              inArrayValueByKey(props.category.tagsList, "id", item.tag_id).title :
              "== || =="}`,
          curList: toArrayClearList(props.category.tagsList, "title"),
          onCurChange: (val) => {
            let _item = item;
            _item.tag_id = val;
            props.update(_item);
          }

        },
        {
          button: item.is_menu ? "eye-open" : "eye", 
          buttonColor: item.is_menu ? "" : "red", 
          onClick: () => {
            let _item = item;
            _item.is_menu = _item.is_menu == 1 ? 0 : 1;
            props.update(_item);
          }
        },
        {
          button: item.is_top_menu ? "eye-open" : "eye", 
          buttonColor: item.is_top_menu ? "" : "red", 
          onClick: () => {
            let _item = item;
            _item.is_top_menu = _item.is_top_menu == 1 ? 0 : 1;
            props.update(_item);
          }
        },


        {
          button: item.is_del == 0 ? "delete" : "delete", onClick: () => {
            let _item = item;
            _item.is_del = 1;
            props.update(_item);
          }
        },
      ])
      if(item.is_menu == 1){
        arr2.push([ 
          {
            button: "open", onClick: () => { 
              navigate(`/products/category/${item.id}`)
            }
          },
          {
            inputSort: `${item.sort}`,
            onBlurInput: (v) => {
              let _item = item;
              let s = _item.sort;
              if(v == 1 ){
                s++;
                _item.sort = s;
              } else {
                s--;
                _item.sort = s;
              } 
              props.update(_item).then(() => props.getCategoryList());
            },
          }, 
          { 
            input: `${item.title}`, 
            onBlurInput: (val) => {
              let _item = item;
              _item.title = val;
              props.update(_item);
            }
          }, 
          {
            curInfo:
              `${inArrayValueByKey(props.category.tagsList, "id", item.tag_id) ?
                inArrayValueByKey(props.category.tagsList, "id", item.tag_id).title :
                "== || =="}`,
            curList: toArrayClearList(props.category.tagsList, "title"),
            onCurChange: (val) => {
              let _item = item;
              _item.tag_id = val;
              props.update(_item);
            }
  
          },
          {
            button: item.is_menu ? "eye-open" : "eye", 
            buttonColor: item.is_menu ? "" : "red", 
            onClick: () => {
              let _item = item;
              _item.is_menu = _item.is_menu == 1 ? 0 : 1;
              props.update(_item);
            }
          },
          {
            button: item.is_top_menu ? "eye-open" : "eye", 
            buttonColor: item.is_top_menu ? "" : "red", 
            onClick: () => {
              let _item = item;
              _item.is_top_menu = _item.is_top_menu == 1 ? 0 : 1;
              props.update(_item);
            }
          },
  
  
          {
            button: item.is_del == 0 ? "delete" : "delete", onClick: () => {
              let _item = item;
              _item.is_del = 1;
              props.update(_item);
            }
          },
        ])
      }
    })
    setTimeout(() => {
      setTableListOrders(arr)  ;
      setTableHomeList(arr2)  ;
    }, 100) 
  }, [props.category.list]);

  return (
    <div id="page" className="home-page">
      <section className="home-info ui-grid">
       
        <div className="home-info-button">
          <UiButtonColor
            color="primary"
            text="Добавить"
            small={true}
            onClick={() => {
              storeData("edit", null);
              navigate("/add/category");
            }}
          />
        </div>
      </section>
      <section className="page-content">
        <div className="page-search">
          <UiInputSearch
            label="Список категорий"
            placeholder="Поиск:"
            onChange={(val) => setSearchLine(val)}
          />
        </div>

        <div className="home-info-text">
          <UiPageText title="Шорт код категории " />
        </div>
        <UiTableAdaptive
          titleList={clientsTitles}
          grid={clientsTitles.length}
          tableList={tableHomeList}
          search={searchLine}
        />
         <div className="home-info-text">
          <UiPageText title="Список всех категорий" />
        </div>

        <UiTableAdaptive
          titleList={clientsTitles}
          grid={clientsTitles.length}
          tableList={tableListOrders}
          search={searchLine}
        />
      </section>
      {/* modal deal add */}
      <UiModalProductAdd
        modalActive={modalDealAddACtive}
        modalClose={() => setModalDealAddActive(false)}
        findUserEvent={props.getUsersByPhone}
        prices={props.settings.prices}
        onCreate={(data) => {
          props.addOrder(data).then(() => {
            setModalDealAddActive(false);
          });
        }}
      />
    </div>
  );
}

export default connect(
  ({ storage, login, comment, logs, user, settings, category }) => ({
    storage,
    login,
    comment,
    logs,
    user,
    settings,
    category
  }),
  {
    getCategoryList: getCategoryListAction,
    getStorageList: getStorageListAction,
    getStorageListByCat: getStorageListByCatAction,
    addStorage: addStorageAction,
    update: updateAction,


  }
)(ProductsCategorys);
